import { Access } from "@p0security/shared/types/access/index";

/** Hacky copy of {@link SPLUNK_STACK_INTEGRATION_MANIFEST} from backend code
 *
 * @deprecated No new development on splunk-stack should occur
 */
export const SplunkStackAccessesHackyCopyOfManifestAvoidReuse = {
  "stack-node": Access({
    label: "Stack node",
    description: "Grant access to a specific node within a stack",
    maturity: "ga",
    delegation: {},
    generated: {},
    parameters: {
      resource: {
        type: "object",
        label: "Requested stack node and role",
        description: "The stack node key and role P0 sends to grant access",
        properties: {
          role: {
            type: "static",
            label: "Role",
            description: "Select the role to grant",
          },
          stackNode: {
            type: "dynamic",
            label: "Stack node",
            description: "Select the stack node",
          },
        },
      },
      value: {
        type: "generated",
        label: "The fully qualified name of the stack node",
      },
      role: {
        type: "generated",
        label: "The role being granted for stack node access",
      },
      category: {
        type: "generated",
        label: "The category of the stack node in question",
      },
      description: {
        type: "generated",
        label: "The shortened identifier of the stack node",
      },
      resourceUrl: { type: "generated", label: "Resource URL" },
    },
    render: { locator: "resource", resource: "value", policy: "role" },
  }),
};
